import React from 'react';
import { withRouter } from 'react-router';
import DropDownMaker from './subcomponents/DropDownMaker';
import styles from '../statics/styles';
import '../statics/stylesheet.css';
import Tabs from 'material-ui/Tabs';
import Tab from 'material-ui/Tabs/Tab';

const getObjectValue = (arr) => {
  const tempArray = [];
  for (let i = 0; i < arr.length; i++) {
    tempArray.push(arr[i]);
  }
  return tempArray;
};

class SizeSelectionWheels extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      staggeredSearch: false
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  getSizes() {
    const data = require('../utils/wheelsFilter.json');
    if (this.state.tire_size_dropdown) {
      return;
    }

    const widthsData = getObjectValue(data.Width);
    const boltPatternsData = getObjectValue(data.BoltPatterns);
    const offsetsData = getObjectValue(data.Offset);
    const sizesData = getObjectValue(data.Sizes);

    this.setState({
      loading: false,
      widths: widthsData,
      boltPatterns: boltPatternsData,
      sizes: sizesData,
      offsets: offsetsData
    });
  }

  fromStyle() {
    if (this.props.inSizes) {
      return 'content-inSizesStyle';
    }
    return 'content-divLength';
  }

  componentWillMount() {
    this.getSizes();
    this.setState({ style: this.fromStyle() });

    if (window.sessionStorage.getItem('staggered') == 'true') {this.setState({ staggeredSearch: true });}
  }

  TabPanel = (props) => {
    const { children, value, index } = props;

    if (!this.state.value) {
      this.state.value = 0;
    }

    return (
			<div
				role="tabpanel"
				id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
       			>
				{value === index && <div>{children}</div>}
			</div>
    );
  };

  a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
      style: { background: 'white', Width: '50%' }
    };
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  render() {

    const { router } = this.context;
    const { loading, staggeredSearch } = this.state;
    const { category, search_by } = this.props.params;

    return (
      <div className={this.state.style}>
        {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
          loading &&
          <div className="sizeSelection-loading">
            <img src={window.host + '/statics/img/loading.svg'} />
          </div> :
          loading &&
          <div className="sizeSelection-loading">
            <img src={window.host + '/statics/img/loading.gif'} />
          </div>
        }
        <div className="sizeSelection-sizeContainer-wheels">

          <div className="sizeSelection-sizeContainer-wheels-desktop">
          <h2 className="content-titleFont">SEARCH {category.toUpperCase()} BY SIZE: </h2>

    <Tabs
      value={this.state.value}
      onChange={this.handleChange}
      className="jss110"
      indicatorColor="primary"
      textColor="primary"
      aria-label="full width tabs example"
      centered="true"
      style={{
        background: 'transparent',
        borderRadius: '12px',
        padding: '8px',
        marginBottom: '20px'
      }}
    >
    <Tab 
      label="✓ Non-Staggered" 
      {...this.a11yProps(0)} 
      style={{
        color: this.state.value === 0 ? '#ffffff' : '#ffffff',
        background: this.state.value === 0 ? 'linear-gradient(135deg, #C50000 0%, #a00000 100%)' : 'rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        margin: '4px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none',
        minHeight: '48px',
        transition: 'all 0.3s ease',
        boxShadow: this.state.value === 0 ? '0 4px 12px rgba(197, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
        border: this.state.value === 0 ? 'none' : '1px solid rgba(255, 255, 255, 0.2)'
      }}
    />
    <Tab 
      label="⚙ Staggered" 
      {...this.a11yProps(1)} 
      style={{
        color: this.state.value === 1 ? '#ffffff' : '#ffffff',
        background: this.state.value === 1 ? 'linear-gradient(135deg, #C50000 0%, #a00000 100%)' : 'rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        margin: '4px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none',
        minHeight: '48px',
        transition: 'all 0.3s ease',
        boxShadow: this.state.value === 1 ? '0 4px 12px rgba(197, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
        border: this.state.value === 1 ? 'none' : '1px solid rgba(255, 255, 255, 0.2)'
      }}
    />
  </Tabs>

  <this.TabPanel value={this.state.value} index={1} style={{ border: '1px red' }}>
 <br/>

<DropDownMaker
buttonlist={[
  { id: 'wheel_size', name: 'Wheel Size', options: this.state.sizes },
  { id: 'wheel_bolt_pattern', name: 'Wheel Bolt Pattern', options: this.state.boltPatterns },
  { id: 'wheel_centerbore', name: 'Center Bore min' },
  { type: 'separator' },
  { id: 'wheel_width_front_min', name: 'Width Front min', options: this.state.widths },
  { id: 'wheel_width_front_max', name: 'Width Front max', options: this.state.widths },
  { type: 'separator' },
  { id: 'wheel_width_rear_min', name: 'Width Rear min', options: this.state.widths },
  { id: 'wheel_width_rear_max', name: 'Width Rear max', options: this.state.widths },
  { type: 'separator2' },
  { id: 'wheels_offset_min', name: 'Wheels Offset min Front' },
  { id: 'wheels_offset_max', name: 'Wheels Offset max Front' },
  { type: 'separator2' },
  { id: 'wheels_offset_min_rear', name: 'Wheels Offset min Rear' },
  { id: 'wheels_offset_max_rear', name: 'Wheels Offset max Rear' }
]}
btnStyle={styles.shoppingMethodButtonWithMargin}
submitButton={{ name: 'Go!', classname: 'btn btn-primary' }}
whenClicked={(options) =>
    this.goToStaggeredURL(
        category,
        search_by,
        this.nvl(options.wheel_size),
        this.nvl(options.wheel_bolt_pattern),
        this.nvl(options.wheel_centerbore),
        this.nvl(options.wheel_offset_min),
        this.nvl(options.wheel_offset_max),
        this.nvl(options.wheel_offset_min_rear),
        this.nvl(options.wheel_offset_max_rear),
        this.nvl(options.wheel_width_front_min),
        this.nvl(options.wheel_width_front_max),
        this.nvl(options.wheel_width_rear_min),
        this.nvl(options.wheel_width_rear_max),
        router)
}
/>
</this.TabPanel>

<this.TabPanel value={this.state.value} index={0}>
 <br/>
 <DropDownMaker
  buttonlist={[
      { id: 'wheel_size', name: 'Wheel Size', options: this.state.sizes },
      { id: 'wheel_bolt_pattern', name: 'Wheel Bolt Pattern', options: this.state.boltPatterns },
      { id: 'wheel_centerbore', name: 'Center Bore min' },
      { type: 'separator2' },
      { id: 'wheel_width_min', name: 'Wheel Width min', options: this.state.widths },
      { id: 'wheel_width_max', name: 'Wheel Width max', options: this.state.widths },
      { type: 'separator2' },
      { id: 'wheels_offset_min', name: 'Wheels Offset min' },
      { id: 'wheels_offset_max', name: 'Wheels Offset max' }
      
  ]}
  btnStyle={styles.shoppingMethodButtonWithMargin}
  submitButton={{ name: 'Go!', classname: 'btn btn-primary' }}
  whenClicked={(options) =>
      this.goToURL(
          category,
          search_by,
          this.nvl(options.wheel_size),
          this.nvl(options.wheel_bolt_pattern),
          this.nvl(options.wheel_centerbore),
          this.nvl(options.wheel_width_min),
          this.nvl(options.wheel_width_max),
          this.nvl(options.wheel_offset_min),
          this.nvl(options.wheel_offset_max),
          router)
  }
/>

</this.TabPanel>

          </div>
          <div className="sizeSelection-sizeContainer-wheels-mobile">
            <h2 className="content-titleFont">SEARCH {category.toUpperCase()} BY SIZE: </h2>
          <Tabs
  value={this.state.value}
  onChange={this.handleChange}
  className="jss110"
  indicatorColor="primary"
  textColor="primary"
  aria-label="full width tabs example"
  centered="true"
  style={{
    background: 'transparent',
    borderRadius: '12px',
    padding: '8px',
    marginBottom: '20px'
  }}
>
  <Tab 
    label="✓ Non-Staggered" 
    {...this.a11yProps(0)} 
    style={{
      color: this.state.value === 0 ? '#ffffff' : '#ffffff',
      background: this.state.value === 0 ? 'linear-gradient(135deg, #C50000 0%, #a00000 100%)' : 'rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      margin: '4px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '600',
      textTransform: 'none',
      minHeight: '48px',
      transition: 'all 0.3s ease',
      boxShadow: this.state.value === 0 ? '0 4px 12px rgba(197, 0, 0, 0.3)' : 'none'
    }}
  />
  <Tab 
    label="⚙ Staggered" 
    {...this.a11yProps(1)} 
    style={{
      color: this.state.value === 1 ? '#ffffff' : '#ffffff',
      background: this.state.value === 1 ? 'linear-gradient(135deg, #C50000 0%, #a00000 100%)' : 'rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      margin: '4px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '600',
      textTransform: 'none',
      minHeight: '48px',
      transition: 'all 0.3s ease',
      boxShadow: this.state.value === 1 ? '0 4px 12px rgba(197, 0, 0, 0.3)' : 'none'
    }}
  />
</Tabs>

<this.TabPanel value={this.state.value} index={1} style={{ border: '1px red' }}>
 <br/>

<DropDownMaker
buttonlist={[
  { id: 'wheel_size', name: 'Wheel Size', options: this.state.sizes },
  { id: 'wheel_bolt_pattern', name: 'Wheel Bolt Pattern', options: this.state.boltPatterns },
  { id: 'wheel_centerbore', name: 'Center Bore min' },
  { type: 'separator' },
  { id: 'wheel_width_front_min', name: 'Width Front min', options: this.state.widths },
  { id: 'wheel_width_front_max', name: 'Width Front max', options: this.state.widths },
  { type: 'separator' },
  { id: 'wheel_width_rear_min', name: 'Width Rear min', options: this.state.widths },
  { id: 'wheel_width_rear_max', name: 'Width Rear max', options: this.state.widths },
  { type: 'separator2' },
  { id: 'wheels_offset_min', name: 'Wheels Offset min Front' },
  { id: 'wheels_offset_max', name: 'Wheels Offset max Front' },
  { type: 'separator2' },
  { id: 'wheels_offset_min_rear', name: 'Wheels Offset min Rear' },
  { id: 'wheels_offset_max_rear', name: 'Wheels Offset max Rear' }
]}
btnStyle={styles.shoppingMethodButtonWithMargin}
submitButton={{ name: 'Go!', classname: 'btn btn-primary' }}
whenClicked={(options) =>
    this.goToStaggeredURL(
        category,
        search_by,
        this.nvl(options.wheel_size),
        this.nvl(options.wheel_bolt_pattern),
        this.nvl(options.wheel_centerbore),
        this.nvl(options.wheel_offset_min),
        this.nvl(options.wheel_offset_max),
        this.nvl(options.wheel_offset_min_rear),
        this.nvl(options.wheel_offset_max_rear),
        this.nvl(options.wheel_width_front_min),
        this.nvl(options.wheel_width_front_max),
        this.nvl(options.wheel_width_rear_min),
        this.nvl(options.wheel_width_rear_max),
        router)
}
/>
</this.TabPanel>

<this.TabPanel value={this.state.value} index={0}>
 <br/>
 <DropDownMaker
  buttonlist={[
      { id: 'wheel_size', name: 'Wheel Size', options: this.state.sizes },
      { id: 'wheel_bolt_pattern', name: 'Wheel Bolt Pattern', options: this.state.boltPatterns },
      { id: 'wheel_centerbore', name: 'Center Bore min' },
      { id: 'wheel_width_min', name: 'Wheel Width min', options: this.state.widths },
      { id: 'wheel_width_max', name: 'Wheel Width max', options: this.state.widths },
      { id: 'wheels_offset_min', name: 'Wheels Offset min' },
      { id: 'wheels_offset_max', name: 'Wheels Offset max' }
  ]}
  btnStyle={styles.shoppingMethodButtonWithMargin}
  submitButton={{ name: 'Go!', classname: 'btn btn-primary' }}
  whenClicked={(options) =>
      this.goToURL(
          category,
          search_by,
          this.nvl(options.wheel_size),
          this.nvl(options.wheel_bolt_pattern),
          this.nvl(options.wheel_centerbore),
          this.nvl(options.wheel_width_min),
          this.nvl(options.wheel_width_max),
          this.nvl(options.wheel_offset_min),
          this.nvl(options.wheel_offset_max),
          router)
  }
/>
</this.TabPanel>

            </div>
        </div>
      </div>
    );
  }
  nvl(data) {
    if (data) {return data;}
    return '';
  }

  goToURL(category, searchBy, wheel_size, wheel_bolt_pattern, wheel_centerbore, wheel_width_min, wheel_width_max, wheel_offset_min, wheel_offset_max, router) {

    console.log('ccccccccc: ' + wheel_centerbore);

    if (this.props.inSizes) {
      const vehicle = this.props.params.options.split(' ').join('%20');
      router.push('/' + category.replace(/ /g, '%20') + '/' + searchBy + '/' + vehicle + '/' + wheel_size + '-' + wheel_bolt_pattern + '-' + wheel_offset_min + '_' + wheel_offset_max + '-' + wheel_width_min + '_' + wheel_width_max);
    } else {
      if (wheel_offset_min && wheel_offset_min === '0') {
        wheel_offset_min = '0.0';
      }
      if (wheel_offset_max && wheel_offset_max === '0') {
        wheel_offset_max = '0.0';
      }
      router.push('/' + category.replace(/ /g, '%20') + '/Size/' + wheel_size + '--' + wheel_bolt_pattern + '--' + wheel_offset_min + '_' + wheel_offset_max + '--' + wheel_width_min + '_' + wheel_width_max + '--' + wheel_centerbore);
    }
  }

  goToStaggeredURL(category, searchBy, wheel_size, wheel_bolt_pattern,  wheel_centerbore, wheel_offset_min, wheel_offset_min_rear, wheel_offset_max, wheel_offset_max_rear, wheel_width_front_min, wheel_width_front_max, wheel_width_rear_min, wheel_width_rear_max, router) {
    window.localStorage.setItem('front offset min', wheel_offset_min);
    window.localStorage.setItem('front offset max', wheel_offset_max);
    window.localStorage.setItem('rear offset min', wheel_offset_min_rear);
    window.localStorage.setItem('rear offset max', wheel_offset_max_rear);
    window.localStorage.setItem('centerbore', wheel_centerbore);
    window.localStorage.setItem('wheel width front min', wheel_width_front_min);
    window.localStorage.setItem('wheel width front max', wheel_width_front_max);
    window.localStorage.setItem('wheel width rear min', wheel_width_rear_min);
    window.localStorage.setItem('wheel width rear max', wheel_width_rear_max);
    if (this.props.inSizes) {
      const vehicle = this.props.params.options.split(' ').join('%20');
      router.push('/' + category.replace(/ /g, '%20') + '/' + searchBy + '/' + vehicle + '/' + wheel_size + '--' + wheel_bolt_pattern + '--' + wheel_offset_min + '_' + wheel_offset_max + '--' + wheel_width_front_min + '_' + wheel_width_front_max + '--' + wheel_width_rear_min + '_' + wheel_width_rear_max );
    } else {
      router.push('/' + category.replace(/ /g, '%20') + '/Size/' + wheel_size + '--' + wheel_bolt_pattern + '--' + wheel_offset_min + '_' + wheel_offset_max_rear +'--' + wheel_width_front_min + '_' + wheel_width_front_max + '--' + wheel_width_rear_min + '_' + wheel_width_rear_max + '--' + wheel_centerbore);
    }
  }
}

SizeSelectionWheels.propTypes = {
  params: React.PropTypes.object.isRequired
};

SizeSelectionWheels.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default withRouter(SizeSelectionWheels);




// WEBPACK FOOTER //
// ./src/components/SizeSelectionWheels.js